<template>
  <div>
    <div class="my-4 fs-30 fw-500 text-center">API Playground</div>
    <div class="p-5 mx-5 bg-white rounded-lg border">
      <div class="d-flex align-items-center mb-3">
        <SfeSelect
            :options="methodOptions"
            v-model="method"
            class="mr-2"
            style="width: 150px"
        />
        <SfeInput
            v-model="url"
            placeholder="https://jsonplaceholder.typicode.com/posts"
            class="flex-grow-1 mr-2"
        />
        <SfeButton @click="sendRequest" :disabled="isLoading">
          {{ isLoading ? 'Sending...' : 'Send' }}
        </SfeButton>
      </div>

      <SfeTabs default-tab="headers" variant="shadowButton" @view:activeTab="activeTab = $event">
        <SfeTabList>
          <SfeTabTrigger value="headers">Headers</SfeTabTrigger>
          <SfeTabTrigger value="body">Body</SfeTabTrigger>
        </SfeTabList>

        <SfeTabContent value="headers">
          <RequestHeaders
              :headers="headers"
              @add-header="addHeader"
              @remove-header="removeHeader"
              @update-header="updateHeader"
          />
        </SfeTabContent>
        <SfeTabContent value="body">
          <RequestBody
              :method="method"
              :body="body"
              @update-body="body = $event"
          />
        </SfeTabContent>
      </SfeTabs>

      <SfeDivider class="my-5" />

      <div>
        <div class="d-flex align-items-center mb-2">
          <SfeStatusBadge
              v-if="response?.status || errorStatus"
              variant="faded"
              :intent="(response?.status === 200 || errorStatus === 200) ? 'positive' : 'critical'"
              class="mr-2"
          >
            {{ response?.status || errorStatus }}
          </SfeStatusBadge>
          <span v-if="response?.statusText">{{ response?.statusText }}</span><span class="ml-2" v-if="responseTime">({{ responseTime }}ms)</span>
        </div>
        <ResponseViewer :response="response" :error="error" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import RequestHeaders from './RequestHeaders.vue'
import RequestBody from './RequestBody.vue'
import ResponseViewer from './ResponseViewer.vue'


export default {
  components: { RequestHeaders, RequestBody, ResponseViewer },
  data() {
    return {
      url: 'https://jsonplaceholder.typicode.com/posts',
      method: 'GET',
      methodOptions: [
        { label: 'GET', value: 'GET' },
        { label: 'POST', value: 'POST' },
        { label: 'PUT', value: 'PUT' },
        { label: 'PATCH', value: 'PATCH' },
        { label: 'DELETE', value: 'DELETE' }
      ],
      headers: [{ id: 1, key: '', value: '' }],
      body: '',
      activeTab: 'headers',
      response: null,
      error: null,
      isLoading: false,
      responseTime: null
    }
  },
  computed: {
    errorStatus() {
      // Try to extract status from error object if available
      if (!this.error) return null
      if (this.error.status) return this.error.status
      if (this.error.response && this.error.response.status) return this.error.response.status
      return null
    }
  },
  methods: {
    addHeader() {
      this.headers.push({ id: Date.now(), key: '', value: '' })
    },
    removeHeader(id) {
      this.headers = this.headers.filter(h => h.id !== id)
    },
    updateHeader(id, field, value) {
      const header = this.headers.find(h => h.id === id)
      if (header) header[field] = value
    },
    async sendRequest() {
      this.isLoading = true
      this.response = null
      this.error = null
      this.responseTime = null
      const config = {
        method: this.method,
        url: this.url,
        headers: this.headers.reduce((acc, h) => {
          if (h.key) acc[h.key] = h.value
          return acc
        }, {})
      }
      if (this.method !== 'GET' && this.body) {
        try {
          config.data = JSON.parse(this.body)
        } catch {
          this.error = 'Invalid JSON body'
          this.isLoading = false
          return
        }
      }
      const start = Date.now()
      try {
        this.response = await axios(config)
        this.responseTime = Date.now() - start
      } catch (err) {
        this.error = err.response || err.message
        this.responseTime = Date.now() - start
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
